var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-video"},[_c('common-video',{attrs:{"video":_vm.code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }